import {IAlertModal, IAdmin} from "@data";
import {atom} from "recoil";
import stateKeys from "./adminStateKeys";

const states = {
  alertState: atom<IAlertModal>({
    key: stateKeys.alertModalKey,
    default: {},
  }),
  adminDataState: atom<IAdmin | undefined>({
    key: stateKeys.adminDataKey,
    default: undefined,
  }),
  loadingState: atom<boolean>({
    key: stateKeys.loadingKey,
    default: false,
  }),
};

export default states;
